package com.yogaaicoach.pages.trainingprogram

import Config
import com.yogaaicoach.common.network.ApiClient
import io.ktor.client.request.post
import io.ktor.client.request.put
import io.ktor.client.request.setBody
import io.ktor.client.statement.HttpResponse

class TrainingProgramApi(private val client: ApiClient) {
    suspend fun createTrainingProgram(trainingProgram: CreateTrainingProgramRequest): HttpResponse {
        return client.client.post("${Config.API_URL}/trainingProgram") {
            setBody(trainingProgram)
        }
    }

    suspend fun updateTrainingProgram(request: UpdateTrainingProgramRequest): HttpResponse {
        return client.client.put("${Config.API_URL}/trainingProgram") {
            setBody(request)
        }
    }

    suspend fun createTrainingProgramBasedOnPrevious(): HttpResponse {
        return client.client.post("${Config.API_URL}/trainingProgramBasedOnPrevious")
    }
}
